import React from 'react'
import setClass from 'classnames'

const ButtonList = props => {
  const buttons = props.buttons.map((button, i) => {
    return {...button, key: i}
  })
  return (
    <div className='buttons'>
      {buttons.map(button => {
        const className = setClass({
          'button': true,
          'is-info': true,
          'is-medium': true,
          'is-outlined': !button.isActive
        })
        return (
          <span key={button.key} onClick={button.onClick} className={className}>
            {button.text}
          </span>
        )
      })}
    </div>
  )
}

export default ButtonList



// WEBPACK FOOTER //
// ./src/components/generic/ButtonList.js